module.exports = __webpack_public_path__ + "static/media/loader.2cf70bc0.gif";